import { useEffect, useState } from "react";
import BalanceTab from "./BalanceTab";

import {
  listarPagos,
  registrarPago,
  me,
  listarSesionesPendientesPago,
  eliminarPago, // ✅ EDITAR/ELIMINAR
  actualizarPago, // ✅ EDITAR/ELIMINAR
} from "../api";

import "./PagosView.css";
import PagosListado from "./PagosListado";
import CierreDia from "./CierreDia";
import CierreMes from "./CierreMes";
import FacturasProfesionales from "./FacturasProfesionales";
import ClientesMesTab from "./ClientesMesTab";

export default function PagosView() {
  const [user, setUser] = useState(null);

  // listado normal
  const [pagos, setPagos] = useState([]);
  const [totalPagos, setTotalPagos] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busqueda, setBusqueda] = useState("");

  // 👉 ingresos previstos por citas pendientes del mes
  const [ingresosPendientesMes, setIngresosPendientesMes] = useState(0);

  // filtro por especialidad (solo CIERRE DE MES)
  const [filtroEspecialidades, setFiltroEspecialidades] = useState({
    psicologia: true,
    "psicologia-adultos": true,
    logopeda: true,
    yoga: true,
    nutricion: true,
  });

  const specialtiesOptions = [
    { code: "psicologia", label: "Psicología" },
    { code: "psicologia-adultos", label: "Psicología Adultos" },
    { code: "logopeda", label: "Logopedia" },
    { code: "yoga", label: "Yoga" },
    { code: "nutricion", label: "Nutrición" },
  ];

  // modal nuevo pago
  const [showModal, setShowModal] = useState(false);
  const [sesionesPendientes, setSesionesPendientes] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("efectivo");
  const [sesionesPendientesMes, setSesionesPendientesMes] = useState([]);

  // ✅ EDITAR/ELIMINAR: modal editar pago
  const [showEditModal, setShowEditModal] = useState(false);
  const [editPago, setEditPago] = useState(null);
  const [editDate, setEditDate] = useState(""); // YYYY-MM-DD
  const [editAmount, setEditAmount] = useState("");
  const [editMethod, setEditMethod] = useState("efectivo");
  const [editStatus, setEditStatus] = useState("pagado");
  const [editEnviado, setEditEnviado] = useState(false);
  const [editNotes, setEditNotes] = useState("");

  // paginación listado
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // pestañas superiores
  const [activeTab, setActiveTab] = useState("listado");

  // estado cierre de día
  const [fechaCierreDia, setFechaCierreDia] = useState(() =>
    new Date().toISOString().slice(0, 10),
  );
  const [loadingCierreDia, setLoadingCierreDia] = useState(false);
  const [errorCierreDia, setErrorCierreDia] = useState("");
  const [pagosCierreDia, setPagosCierreDia] = useState([]);
  const [resumenCierreDia, setResumenCierreDia] = useState({
    total: 0,
    efectivo: 0,
    tarjeta: 0,
    count: 0,
  });

  // estado cierre de mes
  const [mesCierre, setMesCierre] = useState(() =>
    new Date().toISOString().slice(0, 7),
  ); // YYYY-MM
  const [loadingCierreMes, setLoadingCierreMes] = useState(false);
  const [errorCierreMes, setErrorCierreMes] = useState("");
  const [pagosCierreMes, setPagosCierreMes] = useState([]);
  const [resumenCierreMes, setResumenCierreMes] = useState({
    total: 0,
    efectivo: 0,
    tarjeta: 0,
    count: 0,
    totalProfesional: 0,
    totalCentro: 0,
  });

  // ─────────── PORCENTAJE PROFESIONAL ───────────
  const porcentajeProfesional = user?.porcentaje_profesional
    ? Number(user.porcentaje_profesional)
    : 0;
  const porcentajeCentro = 100 - porcentajeProfesional;
  const isAdmin = user?.role === "admin";

  // precios por servicio
  const precios = {
    reeducacion_psicopedagogica: 45,
    estimulacion: 45,
    intervencion_psicoterapia: 200,
    intervencion_estimulacion: 180,
    intervencion_logopedia: 140,
    intervencion_deglucion: 120,
    psicologia_infantojuvenil: 50,
    terapia_familiar: 80,
    psicologia_perinatal: 60,
    asesoramiento_crianza: 45,
    logopedia: 35,
    yoga: 12.4,
    atencion_temprana: 45,
    entrevista_inicial: 50,
    evaluacion_psicologica: 350,
    evaluacion_logopedia: 150,
    consulta_inicial: 0,

    apoyo_lenguaje: 28.93,
    psicoterapia: 50,
    psicopedagogia: 41.32,
    consulta_nutricional: 50,
    educacion_nutricional: 50,
    clase_yoga: 0,
    clase_yoga_mes: 0,
    deglucion: 30,
    intervencion_psicoterapia_mes: 200,
    intervencion_estimulacion_mes: 180,
    intervencion_logopedia_mes: 140,
    reeducacion_pedagogica_NEAE_mes: 180,
    altas_capacidades_NEAE_mes: 180,
    reeducacion_lenguaje_NEAE_mes: 140,
  };

  const normalizeServiceCode = (code) =>
    String(code || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/-+/g, "_");

  const getDefaultPrice = (ses) => {
    if (!ses) return "";

    if (ses.precio != null && ses.precio !== "") return Number(ses.precio);

    const key = normalizeServiceCode(ses.service_code);

    if (key && Object.prototype.hasOwnProperty.call(precios, key)) {
      return Number(precios[key]);
    }

    return "";
  };

  // ✅ EDITAR/ELIMINAR: helper para input date
  const toInputDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
  };

  // ─────────── INGRESOS PENDIENTES DEL MES ───────────
  const calcularIngresosPendientesMes = async (mes) => {
    try {
      const r = await listarSesionesPendientesPago();
      const sesiones = r.items || [];

      const filtradas = sesiones.filter((s) => {
        if (!s.start_datetime) return false;
        const d = new Date(s.start_datetime);
        if (Number.isNaN(d.getTime())) return false;
        return d.toISOString().slice(0, 7) === mes;
      });

      setSesionesPendientesMes(filtradas);

      let total = 0;
      filtradas.forEach((s) => {
        const precio = getDefaultPrice(s);
        total += Number(precio || 0);
      });

      setIngresosPendientesMes(total);
    } catch (e) {
      console.error(e);
      setSesionesPendientesMes([]);
      setIngresosPendientesMes(0);
    }
  };

  // ─────────── CARGA DE USUARIO ───────────
  useEffect(() => {
    me().then((r) => {
      if (r.user) setUser(r.user);
    });
  }, []);

  // ─────────── LISTADO NORMAL (paginado) ───────────
  const loadPagos = async (page = 1) => {
    try {
      setLoading(true);
      const { items, total } = await listarPagos({
        page,
        page_size: itemsPerPage,
      });
      setPagos(items || []);
      setTotalPagos(total ?? 0);
      setError("");
    } catch (e) {
      console.error(e);
      setError("Error al cargar pagos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user) return;
    if (activeTab === "listado") {
      loadPagos(currentPage);
    }
  }, [user, currentPage, activeTab]);

  useEffect(() => {
    setCurrentPage(1);
  }, [busqueda]);

  // ─────────── FUNCIONES DE RESUMEN (cierres) ───────────
  const calcularResumen = (items, porcentajeProf = 0) => {
    let total = 0;
    let efectivo = 0;
    let tarjeta = 0;
    items.forEach((p) => {
      const amt = Number(p.amount) || 0;
      total += amt;
      if (p.payment_method === "efectivo") efectivo += amt;
      else if (p.payment_method === "tarjeta") tarjeta += amt;
    });

    const totalProfesional = (total * porcentajeProf) / 100;
    const totalCentro = total - totalProfesional;

    return {
      total,
      efectivo,
      tarjeta,
      count: items.length,
      totalProfesional,
      totalCentro,
    };
  };

  // ─────────── CIERRE DE DÍA ───────────
  const loadCierreDia = async (fecha) => {
    if (!fecha) return;
    try {
      setLoadingCierreDia(true);

      const ym = fecha.slice(0, 7);

      const { items } = await listarPagos({
        month: ym,
        all_month: 1,
      });

      const filtrados = (items || []).filter((p) => {
        const d = new Date(p.date);
        if (Number.isNaN(d.getTime())) return false;
        return d.toISOString().slice(0, 10) === fecha;
      });

      setPagosCierreDia(filtrados);
      setResumenCierreDia(calcularResumen(filtrados, porcentajeProfesional));
      setErrorCierreDia("");
    } catch (e) {
      console.error(e);
      setErrorCierreDia("Error al cargar cierre de día");
    } finally {
      setLoadingCierreDia(false);
    }
  };

  // ─────────── CIERRE DE MES ───────────
  const loadCierreMes = async (mes) => {
    if (!mes) return;
    try {
      setLoadingCierreMes(true);

      const { items } = await listarPagos({
        month: mes,
        all_month: 1,
      });

      const lista = items || [];

      setPagosCierreMes(lista);
      setResumenCierreMes(calcularResumen(lista, porcentajeProfesional));
      setErrorCierreMes("");
    } catch (e) {
      console.error(e);
      setErrorCierreMes("Error al cargar cierre de mes");
    } finally {
      setLoadingCierreMes(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!isAdmin) return;
    if (activeTab === "cierre-dia") {
      loadCierreDia(fechaCierreDia);
    }
  }, [activeTab, fechaCierreDia, isAdmin]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!isAdmin) return;
    if (
      activeTab === "cierre-mes" ||
      activeTab === "facturas-profesionales" ||
      activeTab === "clientes" ||
      activeTab === "balance"
    ) {
      loadCierreMes(mesCierre);
    }
  }, [activeTab, mesCierre, isAdmin]);

  useEffect(() => {
    if (!user) return;
    if (activeTab === "balance") {
      calcularIngresosPendientesMes(mesCierre);
    }
  }, [activeTab, mesCierre, user]);

  // ─────────── SESIONES PENDIENTES / MODAL ───────────
  const loadPendientes = async () => {
    try {
      const r = await listarSesionesPendientesPago();
      setSesionesPendientes(r.items || []);
    } catch (e) {
      alert("Error al cargar sesiones pendientes");
    }
  };

  const handleNuevoPago = async () => {
    await loadPendientes();
    setSelectedSession(null);
    setAmount("");
    setMethod("efectivo");
    setShowModal(true);
  };

  const handleSeleccionarSesion = (id) => {
    const ses = sesionesPendientes.find((s) => s.id === Number(id));
    setSelectedSession(ses || null);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (selectedSession) {
      const porDefecto = getDefaultPrice(selectedSession);
      setAmount(porDefecto === "" ? "" : String(porDefecto));
    } else {
      setAmount("");
    }
  }, [selectedSession]);

  const handleRegistrarPago = async () => {
    if (!selectedSession) {
      alert("Selecciona una sesión primero");
      return;
    }
    const parsed = parseFloat(amount);

    if (amount === "" || Number.isNaN(parsed) || parsed < 0) {
      alert("Introduce un importe válido (0 o mayor)");
      return;
    }

    try {
      const r = await registrarPago({
        session_id: selectedSession.id,
        amount: parsed,
        payment_method: method,
      });
      alert(`Pago registrado: ${r.amount} € para ${r.patient}`);
      setShowModal(false);
      loadPagos(currentPage);
    } catch (err) {
      alert("Error al registrar pago: " + (err?.message || "desconocido"));
    }
  };

  // ✅ EDITAR/ELIMINAR: abrir modal de edición
  const handleEditarPago = (p) => {
    setEditPago(p);
    setEditDate(toInputDate(p.date));
    setEditAmount(
      p.amount !== null && p.amount !== undefined ? String(p.amount) : "",
    );
    setEditMethod(p.payment_method === "tarjeta" ? "tarjeta" : "efectivo");
    setEditStatus(p.status === "pendiente" ? "pendiente" : "pagado");
    setEditEnviado(!!p.enviado);
    setEditNotes(p.notes || "");
    setShowEditModal(true);
  };

  // ✅ EDITAR/ELIMINAR: guardar edición
  const handleGuardarEdicion = async () => {
    if (!editPago?.id) return;

    const parsed = parseFloat(editAmount);
    if (editAmount === "" || Number.isNaN(parsed) || parsed < 0) {
      alert("Introduce un importe válido (0 o mayor)");
      return;
    }
    if (!editDate) {
      alert("Selecciona una fecha válida");
      return;
    }

    try {
      await actualizarPago({
        id: editPago.id,
        date: editDate, // backend: YYYY-MM-DD
        amount: parsed,
        payment_method: editMethod,
        status: editStatus,
        enviado: editEnviado ? 1 : 0,
        notes: editNotes,
      });

      alert("Pago actualizado ✅");
      setShowEditModal(false);
      setEditPago(null);
      loadPagos(currentPage);
    } catch (err) {
      alert("Error al actualizar pago: " + (err?.message || "desconocido"));
    }
  };

  // ✅ EDITAR/ELIMINAR: eliminar pago
  const handleEliminarPago = async (p) => {
    if (!p?.id) return;
    const nombre = `${p.paciente || ""} ${p.apellidos || ""}`.trim();
    const ok = window.confirm(
      `¿Seguro que quieres eliminar este pago?\n\nPaciente: ${nombre || "—"}\nImporte: ${
        p.amount ?? "—"
      } €\nFecha: ${
        p.date ? new Date(p.date).toLocaleDateString("es-ES") : "—"
      }`,
    );
    if (!ok) return;

    try {
      await eliminarPago(p.id);
      alert("Pago eliminado ✅");
      // si borras el último elemento de la página, puedes quedarte “vacío”.
      // Esto es un ajuste simple: recargar y si la página ya no existe, bajar una.
      const newTotal = Math.max(0, (totalPagos ?? 0) - 1);
      const newTotalPages = newTotal === 0 ? 1 : Math.ceil(newTotal / itemsPerPage);
      const nextPage = Math.min(currentPage, newTotalPages);

      setTotalPagos(newTotal);
      if (nextPage !== currentPage) setCurrentPage(nextPage);

      loadPagos(nextPage);
    } catch (err) {
      alert("Error al eliminar pago: " + (err?.message || "desconocido"));
    }
  };

  // ─────────── PAGINACIÓN (listado) ───────────
  const totalPages =
    totalPagos === 0 ? 1 : Math.ceil(totalPagos / itemsPerPage);

  const handlePrevPage = () => {
    setCurrentPage((p) => Math.max(1, p - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((p) => Math.min(totalPages, p + 1));
  };

  // ─────────── GUARDAS DE ACCESO ───────────
  if (!user) return <div style={{ padding: "1rem" }}>Cargando usuario...</div>;

  const allowedRoles = ["admin", "psicologa", "logopeda", "nutricionista"];
  if (!allowedRoles.includes(user.role)) {
    return <div style={{ padding: "1rem" }}>Acceso restringido.</div>;
  }

  return (
    <div className="pagos-container">
      <h2>Pagos registrados</h2>

      <p className="pagos-user-info">
        Usuario: <strong>{user.email}</strong>{" "}
        {user.nombre && <>({user.nombre})</>} | Rol:{" "}
        <strong>{user.role}</strong>{" "}
        {user.porcentaje_profesional != null && (
          <>
            | Tú: <strong>{porcentajeProfesional}%</strong> · Centro:{" "}
            <strong>{porcentajeCentro}%</strong>
          </>
        )}
      </p>

      {/* PESTAÑAS SUPERIORES */}
      <div className="pagos-tabs">
        <button
          className={activeTab === "listado" ? "active" : ""}
          onClick={() => setActiveTab("listado")}
        >
          📋 Listado
        </button>

        {isAdmin && (
          <>
            <button
              className={activeTab === "cierre-dia" ? "active" : ""}
              onClick={() => setActiveTab("cierre-dia")}
            >
              📅 Cierre de día
            </button>
            <button
              className={activeTab === "cierre-mes" ? "active" : ""}
              onClick={() => setActiveTab("cierre-mes")}
            >
              📆 Cierre de mes
            </button>
            <button
              className={activeTab === "facturas-profesionales" ? "active" : ""}
              onClick={() => setActiveTab("facturas-profesionales")}
            >
              🧾 Facturas profesionales
            </button>
            <button
              className={activeTab === "clientes" ? "active" : ""}
              onClick={() => setActiveTab("clientes")}
            >
              👥 Clientes
            </button>
          </>
        )}

        <button
          className={activeTab === "balance" ? "active" : ""}
          onClick={() => setActiveTab("balance")}
        >
          📊 Balance
        </button>
      </div>

      {/* TAB LISTADO */}
      {activeTab === "listado" && (
        <PagosListado
          pagos={pagos}
          loading={loading}
          error={error}
          busqueda={busqueda}
          setBusqueda={setBusqueda}
          currentPage={currentPage}
          totalPages={totalPages}
          onPrevPage={handlePrevPage}
          onNextPage={handleNextPage}
          onNuevoPago={isAdmin ? handleNuevoPago : undefined}
          canEdit={isAdmin} // ✅ EDITAR/ELIMINAR
          onEditarPago={isAdmin ? handleEditarPago : undefined} // ✅
          onEliminarPago={isAdmin ? handleEliminarPago : undefined} // ✅
        />
      )}

      {/* TAB CIERRE DE DÍA (solo admin) */}
      {activeTab === "cierre-dia" && isAdmin && (
        <CierreDia
          fecha={fechaCierreDia}
          setFecha={setFechaCierreDia}
          pagos={pagosCierreDia}
          resumen={resumenCierreDia}
          loading={loadingCierreDia}
          error={errorCierreDia}
        />
      )}

      {/* TAB CIERRE DE MES (solo admin) */}
      {activeTab === "cierre-mes" && isAdmin && (
        <CierreMes
          mes={mesCierre}
          setMes={setMesCierre}
          pagos={pagosCierreMes}
          resumen={resumenCierreMes}
          filtroEspecialidades={filtroEspecialidades}
          setFiltroEspecialidades={setFiltroEspecialidades}
          specialtiesOptions={specialtiesOptions}
          loading={loadingCierreMes}
          error={errorCierreMes}
        />
      )}

      {/* TAB FACTURAS PROFESIONALES (solo admin) */}
      {activeTab === "facturas-profesionales" && isAdmin && (
        <FacturasProfesionales
          mes={mesCierre}
          setMes={setMesCierre}
          pagosMes={pagosCierreMes}
          loading={loadingCierreMes}
          error={errorCierreMes}
        />
      )}

      {/* TAB CLIENTES (solo admin) */}
      {activeTab === "clientes" && isAdmin && (
        <ClientesMesTab mes={mesCierre} setMes={setMesCierre} />
      )}

      {/* TAB BALANCE (admin y profesionales) */}
      {activeTab === "balance" && (
        <BalanceTab
          mes={mesCierre}
          setMes={setMesCierre}
          ingresos={
            isAdmin ? resumenCierreMes.total : resumenCierreMes.totalProfesional
          }
          pagosMes={pagosCierreMes}
          sesionesPendientes={sesionesPendientesMes}
        />
      )}

      {/* 💰 MODAL REGISTRAR PAGO (solo admin) */}
      {showModal && isAdmin && (
        <div className="modal-bg">
          <div className="modal">
            <h3>Registrar pago</h3>

            <label>Selecciona una sesión:</label>
            <select
              value={selectedSession?.id || ""}
              onChange={(e) => handleSeleccionarSesion(e.target.value)}
            >
              <option value="">-- Selecciona --</option>
              {sesionesPendientes.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.nombre} {s.apellidos} - {s.service_code} (
                  {new Date(s.start_datetime).toLocaleDateString("es-ES")})
                </option>
              ))}
            </select>

            {selectedSession && (
              <p className="session-summary">
                <strong>Paciente:</strong> {selectedSession.nombre}{" "}
                {selectedSession.apellidos} <br />
                <strong>Servicio:</strong> {selectedSession.service_code} <br />
                <strong>Fecha:</strong>{" "}
                {new Date(selectedSession.start_datetime).toLocaleDateString(
                  "es-ES",
                )}
              </p>
            )}

            <label>Método de pago:</label>
            <select value={method} onChange={(e) => setMethod(e.target.value)}>
              <option value="efectivo">Efectivo</option>
              <option value="tarjeta">Tarjeta</option>
            </select>

            <label>Importe (€):</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={amount}
              onChange={(e) => {
                const v = e.target.value;
                if (v === "") return setAmount("");
                const num = Number(v);
                if (!Number.isNaN(num) && num >= 0) setAmount(v);
              }}
              placeholder="Automático según servicio"
            />

            <div className="modal-actions">
              <button onClick={handleRegistrarPago}>💰 Confirmar</button>
              <button className="cancel" onClick={() => setShowModal(false)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✏️ MODAL EDITAR PAGO (solo admin) */}
      {showEditModal && isAdmin && editPago && (
        <div className="modal-bg">
          <div className="modal">
            <h3>Editar pago</h3>

            <p className="session-summary">
              <strong>Paciente:</strong> {editPago.paciente}{" "}
              {editPago.apellidos} <br />
              <strong>Servicio:</strong> {editPago.service_name || "-"} <br />
              <strong>ID pago:</strong> {editPago.id}
            </p>

            <label>Fecha:</label>
            <input
              type="date"
              value={editDate}
              onChange={(e) => setEditDate(e.target.value)}
            />

            <label>Método de pago:</label>
            <select
              value={editMethod}
              onChange={(e) => setEditMethod(e.target.value)}
            >
              <option value="efectivo">Efectivo</option>
              <option value="tarjeta">Tarjeta</option>
            </select>

            <label>Estado:</label>
            <select
              value={editStatus}
              onChange={(e) => setEditStatus(e.target.value)}
            >
              <option value="pagado">Pagado</option>
              <option value="pendiente">Pendiente</option>
            </select>

            <label>Enviado:</label>
            <select
              value={editEnviado ? "1" : "0"}
              onChange={(e) => setEditEnviado(e.target.value === "1")}
            >
              <option value="0">Sin enviar</option>
              <option value="1">Enviado</option>
            </select>

            <label>Importe (€):</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={editAmount}
              onChange={(e) => {
                const v = e.target.value;
                if (v === "") return setEditAmount("");
                const num = Number(v);
                if (!Number.isNaN(num) && num >= 0) setEditAmount(v);
              }}
            />

            <label>Notas:</label>
            <textarea
              value={editNotes}
              onChange={(e) => setEditNotes(e.target.value)}
              placeholder="Notas (opcional)"
              rows={3}
            />

            <div className="modal-actions">
              <button onClick={handleGuardarEdicion}>💾 Guardar</button>
              <button
                className="cancel"
                onClick={() => {
                  setShowEditModal(false);
                  setEditPago(null);
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}